import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { SearchStatus } from "apps-module/app/shared-library/enums/search-status.enum";
import { DestroyableMixin } from "apps-module/app/shared-library/mixins/destroyable.mixin";
import { LockMixin } from "apps-module/app/shared-library/mixins/lock.mixin";
import { ConfigurationService } from "apps-module/app/shared-library/services/configuration/configuration.service";
import { BrowserWindowService } from "apps-module/app/shared-library/services/environment/browser-window.service";
import { EmptyInstance } from "core-library/mixins/empty-instance";
import { filter, merge, of, take, takeUntil } from "rxjs";

import { SearchForm } from "./forms/search.form";
import { SearchConfigurationModel } from "./models/search-configuration.model";
import { SearchFilterModel } from "./models/search-filter.model";
import { SearchResultItemModel } from "./models/search-result-item.model";
import { SearchResultModel } from "./models/search-result.model";
import { SearchParametersService } from "./services/search-parameters.service";
import { SearchService } from "./services/search.service";

@Component({
    selector: TrainingsSearchComponent.SELECTOR,
    templateUrl: "./trainings-search.component.html",
    providers: [ConfigurationService, SearchParametersService, SearchService]
})
export class TrainingsSearchComponent extends DestroyableMixin(LockMixin(EmptyInstance)) implements OnInit {
    public static SELECTOR: string = "pcg-ng-trainings-search";

    public readonly statuses = SearchStatus;

    public configuration: SearchConfigurationModel;
    public results: Array<SearchResultItemModel> = [];
    public searchForm: SearchForm;
    public searchStatus: SearchStatus = SearchStatus.Loading;
    public searchText: string = null;
    public totalItems: number = 0;
    public totalPages: number = 1;

    public constructor(
        private _browserWindowService: BrowserWindowService,
        private _configurationService: ConfigurationService<SearchConfigurationModel>,
        private _domElement: ElementRef,
        private _searchParametersService: SearchParametersService,
        private _searchService: SearchService
    ) {
        super();
    }

    public ngOnInit(): void {
        this._configurationService.initialize(this._domElement);

        this.configuration = this._configurationService.config;

        const queryString = this._browserWindowService.getQueryString();
        const searchParameters = this._searchParametersService.create(queryString, this.configuration);

        this.searchForm = SearchForm.createForm(searchParameters);

        merge(of(searchParameters), this.searchForm.onFormSubmitted)
            .pipe(
                filter(() => !this.isLocked),
                takeUntil(this.onDestroy)
            )
            .subscribe(searchParams => this.invokeSearch(searchParams));
    }

    private invokeSearch(formSearchParameters: SearchFilterModel): void {
        this.searchStatus = SearchStatus.Loading;
        this.searchText = formSearchParameters.searchText;

        this._searchParametersService.set(formSearchParameters);
        this._searchService.search(formSearchParameters)
            .pipe(take(1))
            .subscribe({
                next: (response: SearchResultModel) => {
                    const searchResult = { ...response.value };

                    this.results = [...searchResult.pageItems];
                    this.totalItems = searchResult.totalItems ?? 0;
                    this.totalPages = searchResult.totalPages ?? 1;

                    this.searchStatus = SearchStatus.Success;
                },
                error: () => this.searchStatus = SearchStatus.Error
            });
    }
}
